(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 1970:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(4454);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
var __dirname = "/";

var path = __webpack_require__(7998);
// 当前项目根目录的路径 eg: D:\Work\YQTrackV5\YQTrack.Web.CarrierList
var curPath = __dirname;
// 所有项目的根目录 eg: D:\Work\YQTrackV5
var parentPath = path.resolve(curPath, "../../");
// 构建工具仓库路径
var generalPath = "".concat(parentPath, "/yqtrack.web.general");
// 全局资源的路径 D:\Work\YQTrackV5\YQTrack.Web.Release\res
// 测试环境构建 走release.dev目录
var releasePath =  false ? 0 : "release";
var resPath = "".concat(parentPath, "/yqtrack.web.").concat(releasePath, "/res");
var BUILD_ID_FILE = "BUILD_ID.txt";
var supportLanguage = [
    "default",
    "en",
    "zh-cn",
    "zh-hk",
    "ja",
    "ko",
    "fi",
    "pl",
    "tr",
    "cs",
    "it",
    "de",
    "es",
    "fr",
    "ru",
    "pt",
    "nl",
    "uk",
    "hu",
    "sv",
    "kk",
    "el",
    "th",
    "bg",
    "sk",
    "lt",
    "ro",
    "no",
    "sq",
    "sl",
    "sr",
    "az",
    "da",
    "mk"
];
var langConfig = {
    // 支持的语种
    supportLanguage: supportLanguage,
    resPath: resPath,
    i18nDirPath: path.resolve(__dirname, "../locales"),
    // publickDir: path.resolve(__dirname, "../"),
    BUILD_ID_FILE: BUILD_ID_FILE,
    filename: "global",
    buildTextDir: path.resolve(__dirname, "../locales/".concat(BUILD_ID_FILE))
};
module.exports = langConfig;


/***/ }),

/***/ 5932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ga; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(6091);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(7988);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(2006);
// EXTERNAL MODULE: ./node_modules/.pnpm/js-cookie@3.0.1/node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(6131);
;// CONCATENATED MODULE: ./plugins/ga/helper.js
function lowBrowser() {
    var browserLevel = "normal", updateDom, htmlDom;
    if (!!document.querySelectorAll && !!document.querySelector) {
        updateDom = document.querySelectorAll(".yq-brower-update");
        htmlDom = document.querySelector("html");
        if (updateDom.length < 1) {
            browserLevel = "normal";
        } else {
            if (hasClass(htmlDom, "csscalc")) {
                browserLevel = "low-csscalc";
            } else if (hasClass(htmlDom, "no-csscalc")) {
                browserLevel = "low-no-csscalc";
            } else {
                browserLevel = "low";
            }
        }
    } else {
        browserLevel = "low";
    }
    return browserLevel;
}
function hasClass(el, className) {
    var hasClass;
    if (el.classList) {
        hasClass = el.classList.contains(className);
    } else {
        hasClass = new RegExp("(^| )" + className + "( |$)", "gi").test(el.className);
    }
    return hasClass;
}
function createGUID(tpl, regexp) {
    var time = new Date().getTime();
    return (tpl || "G-xxxxxxxxxxxxxxxx").replace(regexp || /[xy]/g, function(r) {
        var random = (time + Math.random() * 16) % 16 | 0;
        // d = Math.floor(time / 16);
        return (r === "x" ? random : random & 7 | 8).toString(16).toUpperCase();
    });
}

;// CONCATENATED MODULE: ./plugins/ga/index.js
/* provided dependency */ var process = __webpack_require__(8330);
// class Ga {
//     constructor() {}
//     init(){}
//     sendEvent(){}
//     sendPageView(){}
//     sendException(){}
//     sendSocialShare(){}
//     setDimension(){}
// }





var PLATFORM = "reactm";
var VERSION = "reactm-".concat("v129");
var GITHASH = process.env.GITHASH;
var ENV = window.YQ.configs.env;
var DEFAULTCONFIG = {
    // 跟踪器id
    gaId: null,
    // 采样率
    sampleRate: null,
    // 开发环境
    development: false,
    // 测试环境
    test: false,
    // 仿真环境
    release: true,
    // 生产环境
    production: true
};
var Ga = /*#__PURE__*/ function() {
    "use strict";
    function Ga(config) {
        (0,_class_call_check/* default */.Z)(this, Ga);
        this.config = DEFAULTCONFIG;
        this.allowTheReport = false;
        // 将gtag衡量id传入全局变量
        this.gtagId = "";
    }
    (0,_create_class/* default */.Z)(Ga, [
        {
            /**
     *@Description: 初始化ga4(gtm.js)与noscript
    *@param {String} gtmId GTM-ga4媒体ID
    */ key: "initGtmGA",
            value: function initGtmGA(gtmId) {
                // 初始化gtm.js
                try {
                    (function(w, d, s, l, i) {
                        w[l] = w[l] || [];
                        w[l].push({
                            "gtm.start": new Date().getTime(),
                            event: "gtm.js"
                        });
                        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "";
                        j.async = true;
                        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                        f.parentNode.insertBefore(j, f);
                    })(window, document, "script", "dataLayer", gtmId);
                } catch (err) {
                    ;
                }
                // 创建gtm.js的noscript标签
                try {
                    (function(w, d, s, i) {
                        var _noscript = d.createElement(s[0]);
                        var _iframe = d.createElement(s[1]);
                        _iframe.src = "https://www.googletagmanager.com/ns.html?id=" + i;
                        _iframe.width = 0;
                        _iframe.height = 0;
                        _iframe.style.display = "none";
                        _iframe.style.visibility = "hidden";
                        _noscript.appendChild(_iframe);
                        if (d.body.childNodes[0]) {
                            d.body.insertBefore(_noscript, d.body.childNodes[0]);
                        } else {
                            d.body.appendChild(_noscript);
                        }
                    })(window, document, [
                        "noscript",
                        "iframe"
                    ], gtmId);
                } catch (err1) {
                    ;
                }
            }
        },
        {
            /**
    *@Description: 初始化ga4(gtag.js)
    *@param {String} gtmId Gtag-ga4媒体ID
    *@param {Object} config Gtag-ga4 config 相关配置
    *@param {Boolean} globalTag Gtag-ga4 globalTag  全局收集ga4配置
    */ key: "initGtagGA",
            value: function initGtagGA(gtagId, config, globalTag) {
                // 初始化gtag.js 
                try {
                    // (() => {
                    if (true) {
                        (function(document1, url) {
                            var script = document1.createElement("script");
                            script.async = 1;
                            script.src = url;
                            var scriptFirstDom = document1.getElementsByTagName("script")[0];
                            scriptFirstDom.parentNode.insertBefore(script, scriptFirstDom);
                        })(document, "https://www.googletagmanager.com/gtag/js?id=" + gtagId);
                        window.dataLayer = window.dataLayer || [];
                        window.gtag = function() {
                            try {
                                dataLayer.push(arguments);
                            } catch (e) {
                                ;
                            }
                        };
                        window.gtag("js", new Date());
                        // 把传入的gtagId保存到yqg4对象下，这样后续发送事件可以利用到
                        this.gtagId = this.gtagId || gtagId;
                        // 如果只初始化全局衡量ID，自定义事件不发送统计过去
                        if (this.gtagId === "G-Y0R74VDYCP") {
                            this.gtagId = "";
                        }
                        // 自定义维度1-页面
                        var pageName = YQ && YQ.configs && YQ.configs.filePath || "UNKNOW";
                        var _defaultDimension = {
                            "dimension1": pageName,
                            "dimension2": window === null || window === void 0 ? void 0 : window.YQ.configs.lang,
                            "dimension3": lowBrowser(),
                            "dimension4": VERSION,
                            "dimension5": "0"
                        };
                        // 判断是否需要添加配置，否则默认取消gtag的pv发送
                        if (Object.prototype.toString.call(config) === "[object Object]") {
                            // 合并传入配置与基础维度配置
                            for(var key in config){
                                _defaultDimension[key] = config[key];
                            }
                        }
                        // 对于多个config衡量id而言，基础配置set配置使所有衡量id都将继承属性
                        // 内嵌跨域标识
                        window.gtag("set", "cookie_flags", "SameSite=None;Secure");
                        // 设置登录用user_id，由于ga4的pv采用gtag自动发送，uid方面提前抽离方法设置
                        this.setUserId();
                        // 自定义参数配置gtag
                        if (gtagId) {
                            window.gtag("config", gtagId, _defaultDimension);
                        }
                        // 全局数据添加
                        if (globalTag) {
                            window.gtag("config", "G-Y0R74VDYCP", (0,_object_spread/* default */.Z)({
                                "location_global": window && window.location && window.location.pathname
                            }, _defaultDimension));
                        }
                        // 中国大陆
                        if (YQ.country && YQ.country === "CN") {
                            window.gtag("config", "G-6YXZP82DHM", (0,_object_spread/* default */.Z)({
                                "location_global": window && window.location && window.location.pathname
                            }, _defaultDimension));
                        }
                        // seel的gtag
                        window.gtag("config", "G-2MMP7BWRGY", (0,_object_spread/* default */.Z)({
                            "location_global": window && window.location && window.location.pathname
                        }, _defaultDimension));
                    }
                // })(window,document,gtagId);
                } catch (e) {
                    ;
                }
            }
        },
        {
            /**
    * Description: [sendGaEvent GA4事件跟踪: 此方法参数模拟原ga，
    * 由于GA4统计不再像以往GA会有 category、action、label概念与统计，此GA4参数需去后台单独设置维度统计
    * @param  {String} eventName   必须：[事件名称,Require]
    * @param  {Object}    value    非必须：[额外添加的事件]
    * @example
    * sendGaEvent('Seel保险-自动拒绝-咨询按钮',{'event_category':'123'});
    * sendGaEvent('YQinput-filter-结果页追踪');
    */ key: "sendGaEvent",
            value: function sendGaEvent(eventName, value) {
                // 修改ga4额外参数添加设置
                value = value || {};
                var _defaultDimension = {
                    "send_to": this.gtagId
                };
                if (typeof window.gtag === "function") {
                    try {
                        if (Object.prototype.toString.call(value) === "[object Object]" && Object.keys(value).length !== 0) {
                            // 合并传入配置与基础维度配置
                            for(var key in value){
                                _defaultDimension[key] = value[key];
                            }
                        }
                        window.gtag("event", eventName, _defaultDimension);
                    } catch (err) {
                        ;
                    }
                }
            }
        },
        {
            /**
     * 事件跟踪
     * @param {String} category 用户与之互动的对象
     * @param {String} action 互动的类型
     * @param {String} [label] 对事件进行分类（可选）
     * @param {Number} [value] 与事件相关的数值（可选）
     */ key: "sendEvent",
            value: function sendEvent(category, action1, label, value) {
                if (!this.allowTheReport) {
                    return false;
                }
                // 用于传递ga4的parameter1
                var ga4Options = {};
                if (category) {
                    ga4Options.event_category = category;
                }
                if (action1) {
                    ga4Options.event_action = action1;
                }
                if (label) {
                    ga4Options.event_label = label;
                }
                if (value) {
                    ga4Options.value = value;
                }
                try {
                    this.setLoginDimension();
                } catch (e) {
                    ;
                }
                try {
                    this.sendGaEvent(category + "-" + action1, ga4Options);
                } catch (err) {
                    ;
                }
            }
        },
        {
            /**
     * 用户计时统计
     * @param {String}  category 用于将所有用户计时变量归类到相应逻辑组的字符串
     * @param {String}  variable 用于标识要记录的变量的字符串
     * @param {Number}  [value] 向 Google Analytics（分析）报告的历时时间，以毫秒为单位（可选）
     * @param {String}  [label] 可用于提高报告中显示用户计时数据灵活性的字符串（可选）
     */ key: "sendTiming",
            value: function sendTiming(category, variable, value, label) {
                if (!this.allowTheReport) {
                    return false;
                }
                // 用于传递ga4的parameter1
                var ga4Options = {};
                if (category) {
                    ga4Options.event_category = category;
                }
                if (action) {
                    ga4Options.event_action = action;
                }
                if (label) {
                    ga4Options.event_label = label;
                }
                if (value) {
                    ga4Options.value = value;
                }
                try {
                    this.setLoginDimension();
                } catch (err) {
                    ;
                }
                try {
                    this.sendGaEvent(category + "-" + variable, ga4Options);
                } catch (err1) {
                    ;
                }
            }
        },
        {
            /**
     * 上报错误
     * @param {any} stack 错误堆栈
     */ key: "sendException",
            value: function sendException(errInfo) {
                if (!this.allowTheReport) {
                    return false;
                }
                errInfo.md5 = GITHASH;
                errInfo.version = VERSION;
                errInfo.platform = PLATFORM;
                errInfo.env = ENV;
                if (typeof window.gtag === "function") {
                    try {
                        var ref;
                        (ref = window.gtag) === null || ref === void 0 ? void 0 : ref.call(window, "event", "exception", {
                            "description": JSON.stringify(errInfo),
                            "fatal": true // set to true if the exception is fatal
                        });
                    } catch (e) {
                        ;
                    }
                }
            }
        },
        {
            /**
     * 分享（社交互动）
     * @param {String} network 发生操作的网络，例如wechat,facebook
     * @param {String} target 指定社交互动的目标。此值通常是网址，但也可以是任意文字
     */ key: "sendSocialShare",
            value: function sendSocialShare(network, target) {
                this.sendSocial(network, "share", target);
            }
        },
        {
            /**
     * 关注（社交互动）
     * @param {String} network 发生操作的网络，例如wechat,facebook
     * @param {String} target 指定社交互动的目标。此值通常是网址，但也可以是任意文字
     */ key: "sendSocialFollow",
            value: function sendSocialFollow(network, target) {
                this.sendSocial(network, "follow", target);
            }
        },
        {
            /**
     * 社交互动
     * @param {String} socialNetwork 发生操作的社交平台，例如 wechat,facebook
     * @param {String} socialAction 发生的操作类型，例如 follow,share
     * @param {String} target 指定社交互动的目标。此值通常是网址，但也可以是任意文字。
     */ key: "sendSocial",
            value: function sendSocial() {
                var socialNetwork = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : platform, socialAction = arguments.length > 1 ? arguments[1] : void 0, target = arguments.length > 2 ? arguments[2] : void 0;
                if (!this.allowTheReport) {
                    return false;
                }
                var socialTarget = target;
                // #ifdef H5
                socialTarget = location.href;
                // #endif
                // #ifndef H5
                var pages = getCurrentPages();
                var page = (pages[pages.length - 1] || {}).route;
                socialTarget = page;
                // #endif
                try {
                    this.setLoginDimension();
                } catch (err) {
                    ;
                }
                if (typeof window.gtag === "function") {
                    try {
                        var ref;
                        (ref = window.gtag) === null || ref === void 0 ? void 0 : ref.call(window, "event", socialAction, {
                            "event_category": "social",
                            "event_label": socialNetwork,
                            "event_action": socialAction,
                            "value": socialTarget
                        });
                    } catch (err1) {
                        ;
                    }
                }
            }
        },
        {
            /**
     * 发送日志信息
     * @param {String} action 日志交互事件
     * @param {String} [msg] 日志描述（可选）
     */ key: "sendLogInfo",
            value: function sendLogInfo(action1, msg) {
                this.sendLog("LogInfo", action1, msg);
            }
        },
        {
            /**
     * 发送错误日志
     * @param {String} action 日志交互事件
     * @param {String} [msg] 日志描述（可选）
     */ key: "sendLogError",
            value: function sendLogError(action1, msg) {
                this.sendLog("LogError", action1, msg);
            }
        },
        {
            /**
     * 发送日志
     * @param {String} category 日志类型
     * @param {String} action 日志交互事件
     * @param {String} [msg] 日志描述（可选）
     */ key: "sendLog",
            value: function sendLog(category, action1, msg) {
                if (!this.allowTheReport) {
                    return false;
                }
                // 用于传递ga4的parameter1
                var ga4Options = {};
                if (action1) {
                    ga4Options.event_action = action1;
                }
                if (msg) {
                    ga4Options.event_action = msg;
                }
                try {
                    this.setLoginDimension();
                } catch (e) {
                    ;
                }
                try {
                    this.sendGaEvent("LogInfo", ga4Options);
                } catch (err) {
                    ;
                }
            }
        },
        {
            /**
     * 设置自定义指标
     * @param {Number} index 0 < index < 21
     * @param {any} value 指标的值
     */ key: "setMetric",
            value: function setMetric(index, value) {
                if (typeof window.gtag === "function") {
                    try {
                        window.gtag("set", "metric" + index, value);
                    } catch (err) {
                        ;
                    }
                }
            }
        },
        {
            /**
     * 设置自定义维度
     * @param {Number} index 0 < index < 21
     * @param {any} value 维度的值
     */ key: "setDimension",
            value: function setDimension(index, value) {
                if (typeof window.gtag === "function") {
                    try {
                        window.gtag("set", "dimension" + index, value);
                    } catch (e) {
                        ;
                    }
                }
            }
        },
        {
            /**
     * seel业务设置自定义维度
     * @param {Number} index 0 < index < 21
     * @param {any} value 维度的值
     */ key: "setSeelDimension",
            value: function setSeelDimension(index, value) {
                if (typeof window.gtag === "function") {
                    try {
                        window.gtag("set", "seel-dimension" + index, value);
                    } catch (e) {
                        ;
                    }
                }
            }
        },
        {
            /**
     * seel业务事件跟踪
     * @param {String} category 用户与之互动的对象
     * @param {String} action 互动的类型
     * @param {String} [label] 对事件进行分类（可选）
     * @param {Number} [value] 与事件相关的数值（可选）
     */ key: "sendSeelEvent",
            value: function sendSeelEvent(category, action1, label, value) {
                // 测试 seel 模块 GA事件追踪
                // if (!this.allowTheReport) {
                //     return false;
                // }
                // 用于传递ga4的parameter1
                var ga4Options = {};
                if (category) {
                    ga4Options.event_category = category;
                }
                if (action1) {
                    ga4Options.event_action = action1;
                }
                if (label) {
                    ga4Options.event_label = label;
                }
                if (value) {
                    ga4Options.value = value;
                }
                try {
                    this.setLoginDimension();
                } catch (e) {
                    ;
                    ;
                }
                if (typeof window.gtag === "function") {
                    try {
                        var ref;
                        (ref = window.gtag) === null || ref === void 0 ? void 0 : ref.call(window, category + "-" + action1 + "-" + label, (0,_object_spread/* default */.Z)({
                            "send_to": "G-2MMP7BWRGY"
                        }, ga4Options));
                    } catch (err) {
                        ;
                    }
                }
            }
        },
        {
            // ga4设置用户登录角色user_id
            key: "setUserId",
            value: function setUserId() {
                var _Ga4Uid = "";
                // 由于GA4的userId设置，并不是所有项目都需要，v3项目单独写在项目调用即可
                try {
                    // 获取用户gid信息
                    var loginInfo = js_cookie/* default.get */.Z.get("_yq_rc_"), guid = createGUID(), guidName = "_yq_bid", anonymityCode = js_cookie/* default.get */.Z.get(guidName); //取当前cookie中的GUID
                    //判断是否有设置GUID
                    if (!anonymityCode || !!!String(anonymityCode).trim()) {
                        //没有设置，把创建的GUID设置到cookie中，
                        //过期时间为20年，天*年，365*20 = 7300
                        js_cookie/* default.set */.Z.set(guidName, guid, {
                            domain: ".17track.net",
                            expires: 7300,
                            path: "/"
                        });
                        anonymityCode = guid;
                    }
                    if (loginInfo) {
                        var arrLoginInfo = loginInfo.split(".");
                        var userRole = arrLoginInfo[5];
                        var userGid = arrLoginInfo[6];
                        if (userRole && userGid) {
                            _Ga4Uid = userGid;
                        } else {
                            // 原来的cookie没有gid,统一强制删了这个cookie
                            js_cookie/* default.remove */.Z.remove("_yq_rc_", {
                                domain: ".17track.net",
                                path: "/"
                            });
                        }
                    } else {
                        //未登录
                        _Ga4Uid = anonymityCode;
                    }
                } catch (e) {
                    ;
                }
                if (typeof window.gtag === "function") {
                    try {
                        gtag("set", "user_id", _Ga4Uid);
                    } catch (err) {
                        ;
                    }
                }
            }
        },
        {
            /**
     * 设置用户角度维度
     */ key: "setLoginDimension",
            value: function setLoginDimension() {
                try {
                    var loginInfo = js_cookie/* default.get */.Z.get("_yq_rc_");
                    var guidName = "_yq_bid";
                    var anonymityCode = js_cookie/* default.get */.Z.get(guidName); //取当前cookie中的GUID
                    //判断是否有设置GUID
                    if (!anonymityCode || !!!String(anonymityCode).trim()) {
                        var guid = createGUID(); //创建GUID
                        js_cookie/* default.set */.Z.set(guidName, guid, {
                            domain: ".17track.net",
                            expires: 7300,
                            path: "/"
                        });
                        anonymityCode = guid;
                    }
                    if (loginInfo) {
                        var arrLoginInfo = loginInfo.split(".");
                        var userRole = arrLoginInfo[5];
                        var userGid = arrLoginInfo[6];
                        if (userRole && userGid) {
                            // 设置用户角色
                            this.setDimension(5, userRole);
                            // 设置用户Id
                            this.setUser(userGid);
                        } else {
                            // 原来的cookie没有gid,统一强制删了这个cookie
                            js_cookie/* default.remove */.Z.remove("_yq_rc_", {
                                domain: ".17track.net",
                                path: "/"
                            });
                        }
                    } else {
                        //未登录
                        this.setUser(anonymityCode);
                    }
                } catch (e) {
                    ;
                }
            }
        }
    ]);
    return Ga;
}();
/* harmony default export */ var ga = (new Ga());


/***/ }),

/***/ 1703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6091);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4671);


// 接口返回类型  *** 因后端返回不确定暂不使用
// type Result<T> = {
//   code: number
//   message: string
//   data: T
// }
var Request = /*#__PURE__*/ function() {
    "use strict";
    function Request(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Request);
        // 基础配置，url和超时时间
        this.baseConfig = {
            baseURL: "",
            headers: {
            },
            withCredentials: true
        };
        // console.log('initaxios')
        // 使用axios.create创建axios实例
        this.instance = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create(Object.assign(this.baseConfig, config));
        // 请求拦截器
        this.instance.interceptors.request.use(function(config) {
            // console.log('项目请求拦截')
            // if(isNode()){
            //   console.info(`API ${config.url} request: ` )
            //   console.info(`headers: `, config.headers)
            //   console.info(`params: `, config.data)
            // }
            return config;
        }, function(err) {
            return Promise.reject(err);
        });
        // 响应拦截器
        this.instance.interceptors.response.use(function(response) {
            // if(isNode()){
            //   console.info(`API ${response.config.url} response: `)
            //   console.info(`headers: `, response.config.headers)
            //   console.info(`params: `, response.config.data)
            //   console.info(`status: `, response.status)
            //   console.info(`data: `, response.data)
            // }
            return response.data;
        }, function(error) {
            return Promise.reject({
                Code: -1,
                error: error
            });
        });
    }
    var _proto = Request.prototype;
    // 定义请求方法
    _proto.request = function request(config) {
        return this.instance.request(config);
    };
    _proto.get = function get(url, config) {
        return this.instance.get(url, config);
    };
    _proto.post = function post(url, data, config) {
        return this.instance.post(url, data, config);
    };
    _proto.put = function put(url, data, config) {
        return this.instance.put(url, data, config);
    };
    _proto.delete = function _delete(url, config) {
        return this.instance.delete(url, config);
    };
    return Request;
}();
var http = new Request();
if (true) {
    window.$axiosHtpp = http;
}
/* harmony default export */ __webpack_exports__["Z"] = (http);


/***/ }),

/***/ 4857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JC": function() { return /* binding */ SetTrackArchived; },
/* harmony export */   "Lk": function() { return /* binding */ SetOrderTrackNo; },
/* harmony export */   "a1": function() { return /* binding */ GetTrackInfoList; },
/* harmony export */   "dv": function() { return /* binding */ GetTrackLimitAmount; },
/* harmony export */   "m3": function() { return /* binding */ SetTrackActivate; },
/* harmony export */   "xB": function() { return /* binding */ AddTrackInfos; },
/* harmony export */   "zu": function() { return /* binding */ DelTrackNo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5767);
/* harmony import */ var _axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1703);



var url = "https://buyer.17track.net/orderapi/call";
var version = "m1.0";
var timeZoneOffset = new Date().getTimezoneOffset();
// 获取列表
var GetTrackInfoList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, {
                            version: version,
                            method: "GetTrackInfoList",
                            timeZoneOffset: timeZoneOffset,
                            param: param
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function GetTrackInfoList(param) {
        return _ref.apply(this, arguments);
    };
}();
// 删除
var DelTrackNo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(TrackInfoIds) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, {
                            version: version,
                            method: "DelTrackNo",
                            timeZoneOffset: timeZoneOffset,
                            param: {
                                TrackInfoIds: TrackInfoIds
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function DelTrackNo(TrackInfoIds) {
        return _ref.apply(this, arguments);
    };
}();
// 激活
var SetTrackActivate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(TrackInfoIds) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, {
                            version: version,
                            method: "SetTrackActivate",
                            timeZoneOffset: timeZoneOffset,
                            param: {
                                TrackInfoIds: TrackInfoIds
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function SetTrackActivate(TrackInfoIds) {
        return _ref.apply(this, arguments);
    };
}();
// 归档
var SetTrackArchived = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(TrackInfoIds) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, {
                            version: version,
                            method: "SetTrackArchived",
                            timeZoneOffset: timeZoneOffset,
                            param: {
                                TrackInfoIds: TrackInfoIds
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function SetTrackArchived(TrackInfoIds) {
        return _ref.apply(this, arguments);
    };
}();
// 获取限制数量
var GetTrackLimitAmount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, {
                            version: "a1.0",
                            method: "GetTrackLimitAmount",
                            timeZoneOffset: timeZoneOffset,
                            param: ""
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function GetTrackLimitAmount() {
        return _ref.apply(this, arguments);
    };
}();
var AddTrackInfos = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(tracks) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, {
                            version: version,
                            method: "AddTrackInfos",
                            timeZoneOffset: timeZoneOffset,
                            param: {
                                tracks: tracks
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function AddTrackInfos(tracks) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 同步单号
 * @param TrackInfos {Array}
 *  no      单号
 *  rm      备注
 *  w1      第一运输商
 *  w2      第二运输商
 *  ts      追踪状态类型  0 无效追踪 1 待追踪 2 正在追踪 3 已完成
 *  ot      操作类型      1 新增 2 修改 4 删除
 *  isa     是否归档
 *  totop   置顶的时间戳
 */ var SetOrderTrackNo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(TrackInfos) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, {
                            version: "m2.2",
                            method: "SetOrderTrackNo",
                            timeZoneOffset: timeZoneOffset,
                            param: {
                                TrackInfos: TrackInfos
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function SetOrderTrackNo(TrackInfos) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 1077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ GetUser; },
/* harmony export */   "d": function() { return /* binding */ LogOut; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5767);
/* harmony import */ var _axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1703);



var url = "https://user.17track.net/userapi/call";
var baseParms = {
    version: "m1.0",
    timeZoneOffset: new Date().getTimezoneOffset()
};
// 获取用户信息
var GetUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, Object.assign({}, baseParms, {
                            method: "GetUser",
                            sourcetype: "0",
                            param: {}
                        }))
                    ];
                case 1:
                    result = _state.sent();
                    // console.log('result', result)
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function GetUser() {
        return _ref.apply(this, arguments);
    };
}();
// 退出登录
// 获取用户成员当前限制数量信息
var LogOut = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(url, Object.assign({}, baseParms, {
                            method: "Signout",
                            sourcetype: "0",
                            param: {}
                        }))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function LogOut() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 4454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(2006);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_zlbdfqgbumgkalcb6axhval5kq/node_modules/next/script.js
var script = __webpack_require__(8034);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@8.0.5_x7rvsxqezdkyrrrm3g6wkjag24/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-helmet@6.0.0_react@17.0.2/node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(3893);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_zlbdfqgbumgkalcb6axhval5kq/node_modules/next/router.js
var next_router = __webpack_require__(9167);
// EXTERNAL MODULE: ./plugins/seel-business/asset/css/index.css
var css = __webpack_require__(6070);
// EXTERNAL MODULE: ./src/styles/globals.css
var globals = __webpack_require__(3605);
// EXTERNAL MODULE: ./src/utils/index.ts + 2 modules
var utils = __webpack_require__(7817);
// EXTERNAL MODULE: ./node_modules/.pnpm/antd-mobile@5.24.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/antd-mobile/es/global/index.js
var global = __webpack_require__(5456);
// EXTERNAL MODULE: ./node_modules/.pnpm/@reduxjs+toolkit@1.9.7_3m5k4ry2nwm36zz5ojtujpfkvq/node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 8 modules
var redux_toolkit_esm = __webpack_require__(2363);
// EXTERNAL MODULE: ./src/redux/features/user/userSlice.ts
var userSlice = __webpack_require__(70);
// EXTERNAL MODULE: ./src/redux/features/trackLocal/trackLocalSlice.ts
var trackLocalSlice = __webpack_require__(5519);
;// CONCATENATED MODULE: ./src/redux/store.ts



function makeStore() {
    return (0,redux_toolkit_esm/* configureStore */.xC)({
        reducer: {
            trackLocal: trackLocalSlice/* default */.ZP,
            user: userSlice/* default */.ZP
        }
    });
}
var store = makeStore();
/* harmony default export */ var redux_store = (store);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(6091);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(9072);
;// CONCATENATED MODULE: ./src/utils/carrier/index.ts
// import http from 'src/api/axios'


var i18n = {
    country: "ResGCountry",
    expressGroup: "ResGExpressGroup"
};
var CarrierI18nEnum = (/* unused pure expression or super */ null && ([
    "ResGCountry",
    "ResGExpressGroup"
]));
var Carrier = /*#__PURE__*/ function() {
    "use strict";
    function Carrier() {
        (0,_class_call_check/* default */.Z)(this, Carrier);
        this.postal = [];
        this.express = [];
        this.data = {};
        this.carrierList = [];
        this._lock = true;
        this._onceQueue = [];
        this.indexList = [];
        this.isInit = false;
    }
    var _proto = Carrier.prototype;
    _proto.updateCarrier = function updateCarrier(t) {
        if (this.isInit) return;
        this.$t = t;
        // if (!this.postal.length) {
        // 获取运输商资源https://res.17track.net
        // http.get('//res.17track.net/asset/carrier/info/carrier.all.json')
        //     .then((data) => {
        // console.log(data)
        var windows = window;
        this._setData(windows.ResGCarrier || []);
    // localStorage.setItem('his-update-carrier-time', new Date().getTime().toString())
    // localStorage.setItem({
    //     key: 'his-carrier-lang',
    //     data: this.lang
    // })
    // uni.setStorage({
    //     key: 'his-carrier-list',
    //     data: res.data
    // })
    // })
    // .catch(err => {
    //     console.log(err)
    // })
    // .finally(() => this._notify())
    // }
    };
    _proto.processCarrierData = function processCarrierData(arr) {
        var _this = this;
        // const postal: Array<any> = []
        // const express: Array<any> = []
        var carrierList = [];
        var data = {};
        arr.forEach(function(item) {
            data[item.key] = item;
            // if (item.key.toString().length < 6) {
            //     postal.push(item)
            // } else 
            if (item._group) {
                var expressGroupItem = _this.getWord("expressGroup").itemsDict.get(item._group) || {};
                if (expressGroupItem._hideSelect === "false") {
                    carrierList.push(item);
                }
            } else {
                carrierList.push(item);
            }
        });
        carrierList.sort(this.compareAll);
        return {
            // postal,
            // express,
            carrierList: carrierList,
            data: data
        };
    };
    _proto.getWord = function getWord(word) {
        return this.$t(i18n[word]).items || {};
    };
    _proto.processAll = function processAll(list) {
        list.sort(this.compareAll);
        return list;
    };
    //快递排序比较器
    _proto.compareAll = function compareAll(a, b) {
        var _nameA = a._name;
        var _nameB = b._name;
        return _nameA.localeCompare(_nameB);
    };
    _proto.initIndexList = function initIndexList() {
        var charCodeOfA = "A".charCodeAt(0);
        var groups = Array(26).fill("").map(function(_, i) {
            return {
                title: String.fromCharCode(charCodeOfA + i),
                items: []
            };
        });
        ;
    };
    _proto.getLength = function getLength($t) {
        this.updateCarrier($t);
        return this.carrierList.length;
    };
    _proto.getCarrierList = function getCarrierList($t) {
        this.updateCarrier($t);
        return this.carrierList;
    };
    _proto.once = function once(cb) {
        var _this = this;
        if (this._lock) {
            return new Promise(function(resolve) {
                return _this._onceQueue.push([
                    resolve,
                    cb
                ]);
            });
        }
        return cb ? cb : Promise.resolve();
    };
    _proto._setData = function _setData(list) {
        var ref = this.processCarrierData(list), carrierList = ref.carrierList, data = ref.data;
        this.carrierList = carrierList;
        // this.postal = postal
        // this.express = express
        this.data = data;
    };
    _proto._notify = function _notify() {
        while(this._onceQueue.length){
            var ref = (0,_sliced_to_array/* default */.Z)(this._onceQueue.pop(), 2), resolve = ref[0], cb = ref[1];
            resolve();
            cb && cb();
        }
        this._lock = false;
    };
    /**
     * 关键字搜索运输商, 依赖文件, ResGCarrier, ResGExpress, ResGCountry
     * @param inputVal {String} -- 输入的内容
     * @param all {Boolean} -- 是否全搜索
     * @return Object {{keyValue: {}, keys: [], values: []}}
     */ _proto.searchCarrier = function searchCarrier() {
        var inputVal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        inputVal = inputVal.toLowerCase();
        return this.searchAll(inputVal);
    };
    _proto.searchAll = function searchAll(inputVal) {
        var countryKeys = this.searchCountryForVal(inputVal).keys;
        var arr = [];
        // const lang = window.YQ.configs.lang
        this.carrierList.forEach(function(carrier) {
            // const name = (carrier['_name_' + lang] || carrier._name).toLowerCase()
            var _url = carrier._url;
            var _countryKey = carrier._country_iso;
            var _name = carrier._name.toLowerCase();
            var zhCnName = carrier["_name_zh-cn"].toLowerCase();
            var zhHkName = carrier["_name_zh-hk"].toLowerCase();
            if (countryKeys.includes(_countryKey) || _name.indexOf(inputVal) > -1 || zhCnName.indexOf(inputVal) > -1 || zhHkName.indexOf(inputVal) > -1 || inputVal.length > 3 && _url.toLowerCase().indexOf(inputVal) > -1) {
                arr.push(carrier);
            // if (!countryPostalMap[_countryKey]) {
            //     countryPostalMap[_countryKey] = []
            // }
            // countryPostalMap[_countryKey].push(carrier)
            }
        });
        return this.processAll(arr);
    };
    /**
     * 通过输入内容，搜索国家
     * key: countryKey
     * value: country
     * @param inputVal:string
     * @return Object {{keyValue: {}, keys: [], values: []}}
     */ _proto.searchCountryForVal = function searchCountryForVal(inputVal) {
        var keys = [];
        var values = [];
        var keyValue = {};
        var countryItems = this.getWord("country");
        // console.log(countryItems)
        countryItems.forEach(function(country) {
            if (country._mnemonic.indexOf(inputVal) > -1 || country._name.indexOf(inputVal) > -1) {
                keys.push(country.key);
                values.push(country);
                keyValue[country.key] = country;
            }
        });
        return {
            keys: keys,
            values: values,
            keyValue: keyValue
        };
    };
    /**
     * @function
     * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\string-extend.js
     */ _proto.leftFillZero = function leftFillZero(str, n) {
        var newString;
        var oriLen = str.toString().length;
        var maxLen = n;
        var zero = "";
        var i = 0;
        if (maxLen) {
            while(i < maxLen - oriLen){
                zero += "0";
                i++;
            }
            newString = zero + str;
        } else {
            newString = "0" + str;
        }
        return newString;
    };
    /**
     * 获取邮政或快递模型, 获取不到返回空, 依赖文件, ResGCarrier, ResGExpress
     * @param carrierKey {String} -- 邮政或快递Key
     */ _proto.getCarrier = function getCarrier(carrierKey) {
        // this.updateCarrier($t)
        return carrierKey && carrierKey !== "0" ? this.data[Number(carrierKey)] : false;
    };
    /**
     * 获取邮政或快递模型(邮政包括国家exCountry模型, 快递包括分组exGroup模型), 获取不到返回空, 依赖文件, ResGCarrier, ResGExpress, ResGCountry, ResGExpressGroup
     * @param carrierKey {String} -- 邮政或快递Key
     */ _proto.getCarrierFull = function getCarrierFull(carrierKey) {
        if (carrierKey && carrierKey !== "0") {
            var item = this.data[Number(carrierKey)];
            if (item) {
                if (item._country && !item.exCountry) {
                    item.exCountry = this.getWord("country").itemsDict.get(this.leftFillZero(item._country, 4));
                }
                if (item._group && !item.exGroup) {
                    item.exGroup = this.getWord("expressGroup").itemsDict.get(item._group);
                }
                return item;
            }
        }
        return false;
    };
    return Carrier;
}();
/* harmony default export */ var carrier = (new Carrier());

// EXTERNAL MODULE: ./src/redux/hooks.ts
var hooks = __webpack_require__(9853);
;// CONCATENATED MODULE: ./src/redux/InitStore.tsx





// import styles from './Counter.module.css'
function InitStore() {
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var UserState = (0,hooks/* useAppSelector */.CG)(userSlice/* getUserState */.V_);
    (0,react.useEffect)(function() {
        // 初始化本地缓存
        dispatch((0,trackLocalSlice/* initLocalData */.qZ)());
        // 初始化请求用户信息
        if (UserState.status === "loading") {
            // console.log('redux - getuserInfo')
            dispatch((0,userSlice/* queryUser */.tM)());
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
/* harmony default export */ var redux_InitStore = (InitStore);

// EXTERNAL MODULE: ./src/utils/useI18n/index.ts
var useI18n = __webpack_require__(7288);
;// CONCATENATED MODULE: ./src/pages/_app.tsx







// import Head from "next/head"



// import useRem from 'utils/rem'





// 客户端初始化挂载
if (!(0,utils/* isNode */.UG)()) {
    // 挂载运输商
    react.$carrier = carrier;
    // 挂载ga分析
    var ga = (__webpack_require__(5932)/* ["default"] */ .Z);
    window.YQMJsBridge = window.YQMJsBridge || {};
    window.YQMJsBridge.ga = ga;
    // ga4初始化
    try {
        var gtagId = "";
        //根据当前环境切换ga4统计容器
        if (true) {
            gtagId = "G-T631DT2SHH" // M站GA4 ID
            ;
        } else {}
        // 初始化T站对应ga4谷歌分析
        window.YQMJsBridge.ga.initGtagGA(gtagId, "", true);
    } catch (e) {
        ;
    }
    // ga4-Phone
    try {
        if (true) {
            // 全局分享至Phone端、线上才发
            window.gtag("config", "G-5EF85WDY90", {
                "location_global": window && window.location && window.location.pathname
            });
        }
    } catch (e1) {
        ;
    }
// rem初始化
// useRem()
}
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var router = (0,next_router.useRouter)();
    var _getLayout;
    var getLayout = (_getLayout = Component.getLayout) !== null && _getLayout !== void 0 ? _getLayout : function(page) {
        return page;
    };
    (0,react.useEffect)(function() {
        (0,useI18n/* setLang */.W)(router.locale || "en");
    }, []);
    return getLayout(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet.Helmet, {
                htmlAttributes: {
                    lang: router.locale
                },
                meta: [],
                link: [
                    // { rel: 'apple-touch-icon', content: '/apple-icon.png' },
                    {
                        rel: "canonical",
                        href: "https://www.17track.net/".concat(router.locale || "en")
                    },
                    {
                        rel: "manifest",
                        href: "/manifest.json"
                    },
                    {
                        rel: "shortcut icon",
                        href: "//res.17track.net/global-v2/favicon.ico?v=20170712"
                    },
                    {
                        rel: "image_src",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/share.png"
                    },
                    // { rel: "icon", sizes: '192x192', href: '/asset/images/chromebg.png', color: '#003A9B'},
                    {
                        href: "/asset/logo/16x16.png",
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16"
                    },
                    {
                        href: "/asset/logo/32x32.png",
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32"
                    },
                    {
                        rel: "apple-touch-icon",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_152x152.png",
                        sizes: "152x152"
                    },
                    {
                        rel: "apple-touch-icon",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_144x144.png",
                        sizes: "144x144"
                    },
                    {
                        rel: "apple-touch-icon",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_120x120.png",
                        sizes: "120x120"
                    },
                    {
                        rel: "apple-touch-icon",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_114x114.png",
                        sizes: "114x114"
                    },
                    {
                        rel: "apple-touch-icon",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_76x76.png",
                        sizes: "76x76"
                    },
                    {
                        rel: "apple-touch-icon",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_72x72.png",
                        sizes: "72x72"
                    },
                    {
                        rel: "apple-touch-icon",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_60x60.png",
                        sizes: "60x60"
                    },
                    {
                        rel: "apple-touch-icon",
                        href: "https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_57x57.png",
                        sizes: "57x57"
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "//res.17track.net/asset/carrier/info/indicator.".concat(router.locale, ".js"),
                strategy: "beforeInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Provider */.zt, {
                store: redux_store,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(redux_InitStore, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                ]
            })
        ]
    }));
}
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 5519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EL": function() { return /* binding */ TRACK_LIST_KEY; },
/* harmony export */   "Kb": function() { return /* binding */ checkActiveListLimit; },
/* harmony export */   "MR": function() { return /* binding */ getActiveList; },
/* harmony export */   "S4": function() { return /* binding */ getActiveQueryList; },
/* harmony export */   "T$": function() { return /* binding */ deleteActiveItem; },
/* harmony export */   "Y8": function() { return /* binding */ TRACK_LIMIT_AMOUNT; },
/* harmony export */   "Zm": function() { return /* binding */ TRACK_LIST_ARCHIVE_KEY; },
/* harmony export */   "ks": function() { return /* binding */ setActiveQueryList; },
/* harmony export */   "p1": function() { return /* binding */ deleteArchiveItem; },
/* harmony export */   "qZ": function() { return /* binding */ initLocalData; },
/* harmony export */   "sL": function() { return /* binding */ addArchiveItem; },
/* harmony export */   "vL": function() { return /* binding */ getArchiveList; },
/* harmony export */   "zS": function() { return /* binding */ addActiveItem; }
/* harmony export */ });
/* unused harmony exports trackLocalSlice, clearActiveList, clearArchiveList */
/* harmony import */ var _src_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7817);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2363);


var TRACK_LIMIT_AMOUNT = 40 // 本地激活列表限制数量
;
var TRACK_LIST_KEY = "his_track_list" // 激活列表本地缓存key
;
var TRACK_LIST_ARCHIVE_KEY = "his_track_archive_list" // 归档列表本地缓存key
;
var initialState = {
    activeList: [],
    activeQueryList: [],
    archiveList: [] // 归档列表
};
var setLocalStorage = function(key, data) {
    try {
        window.localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
        ;
    }
};
// 校验数据长度
var checkActiveListLimit = function(list, num) {
    if (list.find(function(item) {
        return item.num === num;
    })) return false;
    if (list.length >= TRACK_LIMIT_AMOUNT) {
        // const err = utils.tools.getErrorDesc(=$t, '-11010105', TRACK_LIMIT_AMOUNT)
        return {
            code: "-11010105",
            limit: TRACK_LIMIT_AMOUNT
        };
    }
    return false;
};
// 去重
var clearRepatData = function(list) {
    var arr = [];
    list.forEach(function(item) {
        if (!arr.find(function(aItem) {
            return aItem.num === item.num;
        })) {
            arr.push(item);
        }
    });
    return arr;
};
var trackLocalSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "counter",
    initialState: initialState,
    reducers: {
        // 获取当前本地缓存数据
        initLocalData: function(state) {
            var activeList = JSON.parse(localStorage.getItem(TRACK_LIST_KEY) || "[]");
            var archiveList = JSON.parse(localStorage.getItem(TRACK_LIST_ARCHIVE_KEY) || "[]");
            //  ****** 兼容老版本数据 Start ************* 
            // 是否同步
            var isSync = localStorage.getItem("his-sync-old");
            if (!isSync) {
                var oldActiveList = JSON.parse(localStorage.getItem("his-tracking") || "{}").data || [];
                var oldArchiveList = JSON.parse(localStorage.getItem("his-archived") || "{}").data || [];
                try {
                    localStorage.setItem("his-sync-old", "true");
                } catch (error) {
                    ;
                }
                if (oldActiveList.length) {
                    // console.log('兼容老版本 - 激活数据', oldActiveList)
                    var localOldActiveList = oldActiveList.filter(function(item) {
                        return !item.FTrackInfoId && !activeList.find(function(newItem) {
                            return item.no === newItem.num;
                        });
                    });
                    if (localOldActiveList && localOldActiveList.length) {
                        localOldActiveList.forEach(function(item) {
                            activeList.push({
                                num: item.no
                            });
                        });
                        try {
                            localStorage.setItem(TRACK_LIST_KEY, JSON.stringify(activeList));
                        } catch (error1) {
                            ;
                        }
                    }
                }
                if (oldArchiveList.length) {
                    // console.log('兼容老版本 - 归档数据')
                    var localOldArchive = oldArchiveList.filter(function(item) {
                        return !item.FTrackInfoId && !archiveList.find(function(newItem) {
                            return item.no === newItem.num;
                        });
                    });
                    // console.log('兼容合并数据 - 归档数据', localOldArchive)
                    if (localOldArchive && localOldArchive.length) {
                        localOldArchive.forEach(function(item) {
                            var time = item.trackTime ? new Date(item.trackTime) : new Date();
                            archiveList.push({
                                num: item.no,
                                time: _src_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"].tools.formatTime */ .ZP.tools.formatTime(time)
                            });
                        });
                        try {
                            localStorage.setItem(TRACK_LIST_ARCHIVE_KEY, JSON.stringify(archiveList));
                        } catch (error2) {
                            ;
                        }
                    }
                }
            }
            //  ****** 兼容老版本数据 End ************* 
            state.activeList = activeList;
            state.archiveList = archiveList;
        },
        //  ------------------------ 激活列表操作start -------------------------------
        // 新增
        addActiveItem: function(state, action) {
            var item = action.payload;
            state.activeList.unshift(item);
            var list = clearRepatData(state.activeList);
            state.activeList = list;
            setLocalStorage(TRACK_LIST_KEY, state.activeList);
        },
        // 删除
        deleteActiveItem: function(state, action) {
            var num = action.payload;
            state.activeList = state.activeList.filter(function(item) {
                return item.num !== num;
            });
            setLocalStorage(TRACK_LIST_KEY, state.activeList);
        },
        // 清空
        clearActiveList: function(state) {
            state.activeList = [];
            setLocalStorage(TRACK_LIST_KEY, state.activeList);
        },
        // 存储查询数据信息
        setActiveQueryList: function(state, action) {
            state.activeQueryList = action.payload || [];
        },
        //  ------------------------ 激活列表操作end ---------------------------------
        //  ------------------------ 归档列表操作start -------------------------------
        // 新增
        addArchiveItem: function(state, action) {
            var item = action.payload;
            state.archiveList.unshift(item);
            var list = clearRepatData(state.archiveList);
            state.archiveList = list;
            setLocalStorage(TRACK_LIST_ARCHIVE_KEY, state.archiveList);
        },
        // 删除
        deleteArchiveItem: function(state, action) {
            var num = action.payload;
            state.archiveList = state.archiveList.filter(function(item) {
                return item.num !== num;
            });
            setLocalStorage(TRACK_LIST_ARCHIVE_KEY, state.archiveList);
        },
        // 清空
        clearArchiveList: function(state) {
            state.archiveList = [];
            setLocalStorage(TRACK_LIST_ARCHIVE_KEY, state.archiveList);
        }
    }
});
var _actions = trackLocalSlice.actions;
var initLocalData = _actions.initLocalData, addActiveItem = _actions.addActiveItem, deleteActiveItem = _actions.deleteActiveItem, clearActiveList = _actions.clearActiveList, setActiveQueryList = _actions.setActiveQueryList, addArchiveItem = _actions.addArchiveItem, deleteArchiveItem = _actions.deleteArchiveItem, clearArchiveList = _actions.clearArchiveList;
var getActiveList = function(state) {
    return state.trackLocal.activeList;
};
var getActiveQueryList = function(state) {
    return state.trackLocal.activeQueryList;
};
var getArchiveList = function(state) {
    return state.trackLocal.archiveList;
};
/* harmony default export */ __webpack_exports__["ZP"] = (trackLocalSlice.reducer);


/***/ }),

/***/ 70:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V_": function() { return /* binding */ getUserState; },
/* harmony export */   "_P": function() { return /* binding */ getIsBuyer; },
/* harmony export */   "tM": function() { return /* binding */ queryUser; }
/* harmony export */ });
/* unused harmony exports userSlice, getUserInfo, userInfoSync */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5767);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2363);
/* harmony import */ var _src_api_user__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1077);
/* harmony import */ var _src_api_track__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4857);
/* harmony import */ var _src_redux_features_trackLocal_trackLocalSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5519);






var initialState = {
    userInfo: {},
    memberInfo: {
        ml: 0
    },
    trackLimitAmount: _src_redux_features_trackLocal_trackLocalSlice__WEBPACK_IMPORTED_MODULE_2__/* .TRACK_LIMIT_AMOUNT */ .Y8,
    status: "loading",
    isBuyer: false,
    isLogin: false,
    value: 1
};
var queryUser = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("user/queryUser", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
    var res, error;
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,_src_api_user__WEBPACK_IMPORTED_MODULE_0__/* .GetUser */ .L)()
                ];
            case 1:
                res = _state.sent();
                if (!(res.Json && res.Json.gid && res.Json.FUserRole === 4)) return [
                    3,
                    5
                ];
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    4,
                    ,
                    5
                ]);
                return [
                    4,
                    syncLockTrack()
                ];
            case 3:
                _state.sent();
                return [
                    2,
                    res
                ];
            case 4:
                error = _state.sent();
                return [
                    2,
                    res
                ];
            case 5:
                return [
                    2,
                    res
                ];
        }
    });
}));
var delayDo = function(getState, callback, time) {
    var state = getState().user;
    if (state.status === "loading") {
        var setTimeOutTime = setTimeout(function() {
            delayDo(getState, callback, time);
            clearTimeout(setTimeOutTime);
        }, time || 100);
    } else {
        callback(state);
        return;
    }
};
/**
* 同步单号
* @param tracks {Array}
*  no      单号
*  rm      备注
*  w1      第一运输商
*  w2      第二运输商
*  ts      追踪状态类型  0 无效追踪 1 待追踪 2 正在追踪 3 已完成
*  ot      操作类型      1 新增 2 修改 4 删除
*  isa     是否归档
*  totop   置顶的时间戳
*/ var initTrackSyncData = function(activeList, archiveList) {
    var activeArr = activeList.map(function(item) {
        return {
            no: item.num,
            rm: "",
            w1: "",
            w2: "",
            ot: 1,
            isa: false,
            totop: ""
        };
    });
    var archiveArr = archiveList.map(function(item) {
        return {
            no: item.num,
            rm: "",
            w1: "",
            w2: "",
            ot: 1,
            isa: true,
            totop: ""
        };
    });
    return activeArr.concat(archiveArr);
};
// 同步本地单号
var syncLockTrack = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var ActiveTrack, ArchiveTrack, params;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ActiveTrack = JSON.parse(window.localStorage.getItem(_src_redux_features_trackLocal_trackLocalSlice__WEBPACK_IMPORTED_MODULE_2__/* .TRACK_LIST_KEY */ .EL) || "[]") // 激活数据
                    ;
                    ArchiveTrack = JSON.parse(window.localStorage.getItem(_src_redux_features_trackLocal_trackLocalSlice__WEBPACK_IMPORTED_MODULE_2__/* .TRACK_LIST_ARCHIVE_KEY */ .Zm) || "[]") // 归档
                    ;
                    params = initTrackSyncData(ActiveTrack, ArchiveTrack);
                    if (!(params && params.length)) return [
                        3,
                        2
                    ];
                    // console.log('正在同步运单', params)
                    return [
                        4,
                        (0,_src_api_track__WEBPACK_IMPORTED_MODULE_1__/* .SetOrderTrackNo */ .Lk)(params)
                    ];
                case 1:
                    _state.sent();
                    try {
                        window.localStorage.setItem(_src_redux_features_trackLocal_trackLocalSlice__WEBPACK_IMPORTED_MODULE_2__/* .TRACK_LIST_KEY */ .EL, "[]");
                        window.localStorage.setItem(_src_redux_features_trackLocal_trackLocalSlice__WEBPACK_IMPORTED_MODULE_2__/* .TRACK_LIST_ARCHIVE_KEY */ .Zm, "[]");
                    } catch (error) {
                        ;
                    }
                    return [
                        2,
                        true
                    ];
                case 2:
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return function syncLockTrack() {
        return _ref.apply(this, arguments);
    };
}();
var userSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "counter",
    initialState: initialState,
    reducers: {},
    extraReducers: function extraReducers(builder) {
        builder.addCase(queryUser.pending, function(state) {
            state.status = "loading";
        // console.log(state.status, action)
        }).addCase(queryUser.fulfilled, function(state, action) {
            state.status = "succeeded";
            // console.log(state.status, action)
            var res = action.payload;
            var Json = res.Json || {};
            if (Json && Json.gid) {
                var ms = (Json.ms || [])[0];
                var isBuyer = res.Json.FUserRole === 4;
                state.userInfo = res.Json;
                state.isBuyer = isBuyer;
                state.memberInfo = ms || {};
                state.isLogin = true;
            } else {
                // 未登录
                state.userInfo = {};
                state.isBuyer = false;
                state.isLogin = false;
            // console.log(res.Message || '')
            }
        }).addCase(queryUser.rejected, function(state) {
            state.status = "failed";
        // console.log(state.status, action)
        });
    }
});
// export const { incrementByAmount } = userSlice.actions
var getUserInfo = function(state) {
    return state.user.userInfo;
};
var getIsBuyer = function(state) {
    return state.user.isBuyer;
};
var getUserState = function(state) {
    return state.user;
};
var userInfoSync = function(callback) {
    return function(dispatch, getState) {
        // console.log(getState().user)
        delayDo(getState, callback);
    };
};
// export const getIsBuyer = (callback: Function): AppThunk =>
// (dispatch, getState) => {
//   delayDo(getState, (callBackState: UserState) => {
//     const isBuyer = callBackState.userInfo.FUserRole === 4
//     callback(isBuyer)
//   })
// }
/* harmony default export */ __webpack_exports__["ZP"] = (userSlice.reducer);


/***/ }),

/***/ 9853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CG": function() { return /* binding */ useAppSelector; },
/* harmony export */   "TL": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* unused harmony exports useForm, useInterval */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9496);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(251);








var useForm = function(defaultValues) {
    return function(handler) {
        return function() {
            var _ref = _async_to_generator(function(event) {
                var form, elements, data;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            event.preventDefault();
                            event.persist();
                            form = event.target;
                            elements = Array.from(form.elements);
                            data = elements.filter(function(element) {
                                return element.hasAttribute("name");
                            }).reduce(function(object, element) {
                                return _object_spread_props(_object_spread({}, object), _define_property({}, "".concat(element.getAttribute("name")), element.value));
                            }, defaultValues);
                            return [
                                4,
                                handler(data)
                            ];
                        case 1:
                            _state.sent();
                            form.reset();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
var useInterval = function(callback, delay) {
    var savedCallback = useRef();
    useEffect(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    useEffect(function() {
        var handler = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _ref;
            var ref;
            return (ref = savedCallback.current) === null || ref === void 0 ? void 0 : (_ref = ref).call.apply(_ref, [
                savedCallback
            ].concat(_to_consumable_array(args)));
        };
        if (delay !== null) {
            var id = setInterval(handler, delay);
            return function() {
                return clearInterval(id);
            };
        }
    }, [
        delay
    ]);
};
// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9;


/***/ }),

/***/ 7817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ utils; },
  "UG": function() { return /* binding */ isNode; }
});

// UNUSED EXPORTS: getLocalLang, getUrlParam

// EXTERNAL MODULE: ./node_modules/.pnpm/js-cookie@3.0.1/node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(6131);
// EXTERNAL MODULE: ./config/i18nConfig.js
var i18nConfig = __webpack_require__(7904);
;// CONCATENATED MODULE: ./src/utils/assemble/func.ts
/* harmony default export */ var func = ({
    verifyNumI18nEnum: [
        "ResGTrack"
    ],
    /**
   * @Date: 2022-10-31 11:01:22
   * @method: 校验单号
   * @param {string} str 单号
   * @return {string} 返回错误信息词条内容或空
   * @Author: wzt
   */ verifyNum: function verifyNum(str) {
        var mix = 5;
        var max = 50;
        if (str === "") {
            return "ResGTrack.global.__inputMsg_null";
        }
        if (str.length < mix || str.length > max) {
            return "ResGTrack.global.__inputMsg_character";
        }
        if (!/^[A-Z0-9_.\-/]{5,50}$/g.test(str)) {
            return "ResGTrack.global.__inputMsg_illegal";
        }
        return "";
    },
    getDownloadUrl: function getDownloadUrl() {
        var userAgent = navigator.userAgent.toLowerCase();
        var u = navigator.userAgent;
        var isWeixin = userAgent.indexOf("micromessenger") !== -1;
        var isIos = u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1;
        var href = "";
        // console.log(userAgent, u, isWeixin, isIos)
        // ios
        if (isIos) {
            href = "https://apps.apple.com/cn/app/id1004956012";
        } else {
            var country = window.YQ.country;
            var lang = window.YQ.configs.lang;
            // 国家不是中国，跳到谷歌play应用商店
            if (country && country !== "CN" || !country && lang !== "zh-cn") {
                href = "https://play.google.com/store/apps/details?id=yqtrack.app";
            } else {
                // 微信
                if (isWeixin) {
                    href = "https://a.app.qq.com/o/simple.jsp?pkgname=yqtrack.app";
                } else {
                    // 国内应用商店
                    href = "//download.17track.net/17track.apk";
                }
            }
        }
        return href;
    },
    debounce: function debounce(func, delay) {
        var _this = this;
        var timeout = null;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (timeout !== null) {
                clearTimeout(timeout);
            }
            var context = _this;
            timeout = setTimeout(function() {
                func.apply(context, args);
            }, delay);
        };
    },
    queryURLParams: function queryURLParams(URL, key) {
        // const url = location.search; // 项目中可直接通过search方法获取url中"?"符后的字串
        if (!URL) return {};
        var url = URL.split(key || "?")[1];
        var obj = {} // 声明参数对象
        ;
        var arr = url.split("&") // 以&符号分割为数组
        ;
        for(var i = 0; i < arr.length; i++){
            var arrNew = arr[i].split("=") // 以"="分割为数组
            ;
            obj[arrNew[0]] = arrNew[1];
        }
        return obj;
    },
    // 获取链接参数
    getUrlParams: function getUrlParams(key) {
        var search = this.queryURLParams(window.location.search);
        var hash = this.queryURLParams(window.location.hash, "#");
        // search = new URLSearchParams(search)
        // hash = new URLSearchParams(hash)
        var value = search[key] || hash[key] || "";
        if (key === "nums" && value.indexOf(",") !== -1) {
            value = value.split(",")[0];
        }
        return value;
    }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(1962);
// EXTERNAL MODULE: ./node_modules/.pnpm/antd-mobile@5.24.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/antd-mobile/es/index.js + 73 modules
var es = __webpack_require__(8179);
;// CONCATENATED MODULE: ./src/utils/assemble/tools.ts


/* harmony default export */ var tools = ({
    /**
   * formatTime - 格式化时间
   * @param  {time} 标准时间格式
   * @param  {String}  format 时间格式结构，比如 yyyy-MM-dd HH:mm:ss
   * @return {String} 格式化后的时间
   */ formatTime: function formatTime(time, format) {
        if (typeof time === "string") {
            time = time.replace(/-/g, "/");
        }
        var t = new Date(time);
        var sFormat = format || "yyyy-MM-dd HH:mm:ss";
        var tf = function tf(i) {
            return (i < 10 ? "0" : "") + i;
        };
        return sFormat.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
            switch(a){
                case "yyyy":
                    return tf(t.getFullYear());
                    break;
                case "MM":
                    return tf(t.getMonth() + 1);
                    break;
                case "mm":
                    return tf(t.getMinutes());
                    break;
                case "dd":
                    return tf(t.getDate());
                    break;
                case "HH":
                    return tf(t.getHours());
                    break;
                case "ss":
                    return tf(t.getSeconds());
                    break;
            }
        });
    },
    // 判断时间格式是否正确
    isValidDate: function isValidDate(date) {
        return (0,_instanceof/* default */.Z)(date, Date) && !isNaN(date.getTime());
    },
    /**
   * @function ISO时间格式化
   */ getFormatIsoTime: function getFormatIsoTime(time, flaggmt, format) {
        if (!time) return "";
        // if (typeof time === 'string') {
        //   time = time.replace(/-/g, '/')
        // }
        if (!this.isValidDate(new Date(time))) return time;
        var timeArr = time.split(/\T|\+|\-/);
        var isoTime = new Date(timeArr[0] + "/" + timeArr[1] + "/" + timeArr[2] + " " + timeArr[3]);
        var formatIsoTime = "";
        if (flaggmt) {
            formatIsoTime = this.formatTime(isoTime, format) + " " + this.getGMT();
        } else {
            formatIsoTime = this.formatTime(isoTime, format);
        }
        return formatIsoTime;
    },
    /**
   * @function UTC时间转本地时间
   */ getLocalTime: function getLocalTime(time, flaggmt, format) {
        if (!time) return "";
        if (typeof time === "string") {
            time = time.replace(/-/g, "/");
        }
        var localTime = "";
        if (flaggmt) {
            localTime = this.formatTime(time, format) + " " + this.getGMT();
        } else {
            localTime = this.formatTime(time, format);
        }
        return localTime;
    },
    getZeroTime: function getZeroTime(time, flaggmt, format) {
        if (!time) return "";
        if (typeof time === "string") {
            time = time.replace(/-/g, "/");
        }
        var localTime = "";
        var ref = this.getGMT(true), hour = ref.hour, min = ref.min;
        var timeStr = new Date(time).valueOf() + hour * 60 * 60 * 1000 + min * 60 * 1000;
        if (flaggmt) {
            localTime = this.formatTime(timeStr, format) + " " + this.getGMT();
        } else {
            localTime = this.formatTime(timeStr, format);
        }
        return localTime;
    },
    /**
   * @function 得到GMT格式
   * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\datetime-extend.js
   */ getGMT: function getGMT(flag) {
        var dt = new Date();
        var iOffset = dt.getTimezoneOffset(); //当地时间与GMT时间的偏移
        var sHour = Math.floor(Math.abs(iOffset / 60));
        var sMin = Math.abs(iOffset % 60);
        if (flag) {
            return {
                hour: sHour,
                min: sMin
            };
        }
        var sGMT;
        if (sHour < 10) {
            sHour = "0" + sHour;
        }
        if (sMin < 10) {
            sMin = "0" + sMin;
        }
        if (iOffset < 0) {
            sGMT = "(GMT" + "+" + sHour + ":" + sMin + ")";
        } else if (iOffset > 0) {
            sGMT = "(GMT" + "-" + sHour + ":" + sMin + ")";
        } else {
            sGMT = "(GMT+00:00)";
        }
        return sGMT;
    },
    /**
   * @function 得到GMT格式
   * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\string-extend.js
   */ leftFillZero: function leftFillZero(str, n) {
        var newString;
        var oriLen = String(str).length;
        var maxLen = n;
        var zero = "";
        var i = 0;
        if (maxLen) {
            while(i < maxLen - oriLen){
                zero += "0";
                i++;
            }
            newString = zero + str;
        } else {
            newString = "0" + str;
        }
        return newString;
    },
    //
    /**
   * @function 格式化预定字符串
   * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\string-extend.js
   */ strFormat: function strFormat(str, array) {
        var reg;
        var i = 0;
        var length = array.length;
        if (Object.prototype.toString.call(array) === "[object Array]") {
            for(; i < length; i++){
                if (array[i] !== undefined) {
                    reg = new RegExp("({)" + i + "(})", "g");
                    str = str.replace(reg, array[i]);
                }
            }
        } else {
            ;
        }
        return str;
    },
    /**
   * @function 按key参数，替换str中前后对应的符号为空字符
   * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\string-extend.js
   */ trimStr: function trimStr(str, key) {
        var last;
        if (str.substring(0, 1) == key) {
            str = str.substr(1);
        }
        last = str.substr(str.length - 1);
        if (last == key) {
            str = str.substring(0, str.length - 1);
        }
        return str;
    },
    /**
   * [format 字符串占位符格式化]
   * @param result {String} 字符串内容
   * @param args args 必须是一个数组
   * @return {String}  格式化后的字符串
   * eg: YQStr.format("词条{0}{1}"，['参数1','参数2']);
   */ format: function format(result, args) {
        var reg;
        if (Object.prototype.toString.call(args) === "[object Array]") {
            for(var i = 0; i < args.length; i++){
                if (args[i] !== undefined) {
                    reg = new RegExp("({)" + i + "(})", "g");
                    result = result.replace(reg, args[i]);
                }
            }
        } else {
            ;
        }
        return result;
    },
    h5Copy: function(content) {
        if (!document.queryCommandSupported("copy")) {
            // 不支持
            return false;
        }
        var textarea = document.createElement("textarea");
        textarea.value = content;
        textarea.readOnly = true;
        document.body.appendChild(textarea);
        textarea.select() // 选择对象
        ;
        textarea.setSelectionRange(0, content.length) //核心
        ;
        var result = document.execCommand("copy") // 执行浏览器复制命令
        ;
        textarea.remove();
        return result;
    },
    copy: function copy(params) {
        if (!params.text) return;
        if (this.h5Copy(params.text)) {
            es/* Toast.show */.FN.show(params.copySuccessMsg);
        }
    },
    getErrorDesc: function getErrorDesc($t, code) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        var result = "";
        var key = code == 0 ? code : "-" + code.toString().replace("-", "");
        var dict = $t("ResGErrorCode.items.itemsDict.data.".concat(key));
        if (dict) {
            result = dict._desc;
            if (result && args.length) {
                result = this.strFormat(result, args);
            }
        }
        return result;
    }
});

;// CONCATENATED MODULE: ./src/utils/index.ts




//判断是否node环境
var isNode = function() {
    return "object" === "undefined";
};
/**
 * 通过URL返回参数集合对象或参数值
 * @param {String} sUrl   url
 * @param {[String]} sKey   参数key, 传了返回value, 不传返回参数集合对象
 * @returns {Object | String} { a: '', b: ''} | ''
 */ var getUrlParam = function getUrlParam(sUrl, sKey) {
    var result = {};
    sUrl.replace(/\??(\w+)=([\w.\-+]+)&?/g, function(a, k, v) {
        if (result[k] !== void 0) {
            var t = result[k];
            result[k] = [].concat(t, v);
        } else {
            result[k] = v;
        }
        return "";
    });
    if (sKey === void 0) {
        return result;
    } else {
        return result[sKey] || "";
    }
};
/**
 * @Date: 2022-10-12 16:34:35
 * @method: 根据请求返回词条语言
 * @param {string} path 请求路径  /en/track
 * @param {NextApiRequest} req   请求体
 * @return {sting} lang 语言
 * @return {boolean} isI18n 链接中是否包含语言
 * @Author: wzt
 */ var getLocalLang = function(path, req) {
    var pathArr = path.split("/").filter(function(item) {
        return item;
    });
    var firstPath = pathArr && pathArr.length ? pathArr[0] : "";
    var isI18n = supportLanguage.indexOf(firstPath) !== -1;
    var v5_Culture = req ? req.cookies.v5_Culture : jsCookie.get("v5_Culture");
    var lang = isI18n ? firstPath : v5_Culture || "en";
    return {
        lang: lang,
        isI18n: isI18n
    };
};
/* harmony default export */ var utils = ({
    func: func,
    tools: tools
});


/***/ }),

/***/ 7288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useI18n; },
/* harmony export */   "W": function() { return /* binding */ setLang; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9692);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6131);


var init = function(V5Front) {
    var _loop = function(key) {
        var ref;
        if ((ref = V5Front[key].items) === null || ref === void 0 ? void 0 : ref.itemsDict) return {
            v: void void 0
        };
        V5Front[key].items.itemsDict = {
            data: {},
            put: function put(e, i) {
                this.data[e] = i;
            },
            get: function get(key) {
                try {
                    return this.data[key];
                } catch (err) {
                    return null;
                }
            }
        };
        for(var i = 0, len = V5Front[key].items.length; i < len; i++){
            V5Front[key].items.itemsDict.put(V5Front[key].items[i].key, V5Front[key].items[i]);
        }
    };
    for(var key in V5Front){
        var _ret = _loop(key);
        if ((0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ret) === "object") return _ret.v;
    }
    mergeError(V5Front);
};
// 合并ErrorCode词条
var mergeError = function(V5Front) {
    var reg = /.+[^G]ErrorCode$/g;
    // 把项目级的error合并到V5Front.ResGErrorCode.items.itemsDict,直接调用它的put和get
    for(var item in V5Front){
        var result = item.match(reg);
        if (result) {
            V5Front[item].items.forEach(function(dict) {
                V5Front.ResGErrorCode.items.itemsDict.put(dict.key, dict);
            });
        }
    }
};
var useI18n = function(V5Front) {
    init(V5Front);
    return function(_key, _defValue) {
        var arr = _key.split(".");
        // 获取V5Front
        var result = V5Front;
        // console.log(result)
        //循环根据词条获取多语言的值
        var fnResult = function() {
            if (!result) return "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    result = result[item];
                    if (!result) {
                        return result;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return result;
        };
        var val = fnResult();
        if (!val) {
            ;
        }
        return val || _defValue || "";
    };
};
/**
 * @Date: 2022-10-26 10:07:35
 * @method: 设置语言
 * @param {string} lang 语言
 * @return {*}
 * @Author: wzt
 */ var setLang = function(lang) {
    var KEY = "v5_Culture";
    // console.log(lang, jsCookie.get(KEY), '1111')
    // 重置v5_Culture
    if (lang !== js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(KEY)) {
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(KEY, {
            domain: "m.17track.net",
            path: "/"
        });
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(KEY, {
            domain: "t.17track.net",
            path: "/"
        });
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(KEY, {
            domain: "extcall.17track.net",
            path: "/"
        });
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(KEY, {
            path: "/"
        });
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(KEY);
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(KEY, lang, {
            domain: "17track.net",
            expires: 365,
            path: "/"
        });
    // TODO 。。。请求接口.....
    }
};


/***/ }),

/***/ 6070:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3605:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [325,179], function() { return __webpack_exec__(1970), __webpack_exec__(8101); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);